import { convertFormDateValueToKnmDataDate } from 'KnmPackage/MainModule/common/convertFormDateValueToKnmDataDate';
import { IKnmErknmActRemark } from 'APIPackage/KnmModule/interfaces/IKnmErknmActRemark';

import { handleReactQuillDeltaValue } from '../../../functions/handleReactQuillDeltaValue';
import { IKnmErknmActRemarkForm } from '../interfaces/IKnmErknmActRemarkForm';

export const convertActRemarksFormToData = (
  remarks: IKnmErknmActRemarkForm[] | undefined,
): IKnmErknmActRemark[] | null => {
  if (!remarks) return null;

  return remarks.map(remark => ({
    guid: remark.guid || null,
    isNew: remark.isNew || null,
    refusedToFamiliarize: remark.refusedToFamiliarize || null,
    fromEpgu: remark.fromEpgu || null,
    text: remark.text || null,
    textReactQuillEditor: handleReactQuillDeltaValue(remark.textReactQuillEditor || remark.text || null),
    signerFullName: remark.signerFullName || null,
    signerPosition: remark.signerPosition || null,
    date: remark.date ? convertFormDateValueToKnmDataDate(remark.date) : null,
    signatureInfo: remark.signatureInfo || null,
  }));
};
